<!--
Voting ballot box screen
@author ab557z
-->
<template>
  <div id="contain" class="container">
  <Nav name="Enter Preferences" :home="true" />
  <VoteConfirm ref="voteConfirm" />
  <div class="vContainer">
    <p class="votingHdr">{{election.name}}</p>
    <p class="votingInstructions">
      Enter number <b>1</b> against your most preferred candidate, <b>2</b> against your second,
      and so on for as many candidates as you wish to vote for.
    </p>
  </div>
  <div style="border-top:1px solid #e4e4e4;border-bottom:1px solid #e4e4e4;margin-bottom:24px;">
        <p class="votingSeatHdr">Total of {{election.numberOfSeats}} seat<span v-if="election.numberOfSeats>1">s</span> available</p>
  </div>
  <div class="vContainer">
        <div v-if="invalidFlag">
              <p style="color:#B30C00;font-weight:bold;">The ballot paper has invalid values. Please try again.</p>
        </div>
        <form target="_blank" method="POST" name="voteForm" autocomplete="off" >
        <ul class="list-group menuUl">
          <Candidate v-for="(candidate,index) in candidates" :key="index" :i="index" :candidate="candidate"/>
          </ul>

            <input type="button" value="Submit Vote" id="submitVote" @click="vote" class="list-group-item list-group-item-primary voteButton"/>
            <input type="button" value="Spoil Vote" id="spoilVote" @click="spoil" class="list-group-item list-group-item-primary voteButton"/>

          <input type="hidden" name="submitButton" id="submitButton" value="" />
          <input type="hidden" name="clientToken" id="clientToken" :value="token" />
        </form>
        <div style="margin-top:16px;text-align:center;">
          <a style="color:var(--uog-dark-blue);font-weight:bold;" target="_blank" href="https://glasgow.saasiteu.com/Modules/SelfService/Login.aspx?ProviderName=University%20of%20Glasgow&Tab=ServiceCatalog&CommandId=NewServiceRequestByOfferingId&Template=DCCA5F9724D34B7687ECD59F0577726C">Contact the UofG Helpdesk</a>
        </div>
  </div>
  </div>
</template>

<script setup>
//Utilities
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'
const route = useRoute()
const router = useRouter()

//Components
import VoteConfirm from '@/components/VoteConfirm.vue'
import Candidate from '@/components/voting/Candidate.vue'

//Data
const candidates = ref({})
const election = ref({})
const token = ref({})
const invalidFlag = ref(false)
const submitData = ref({})

//Element refs
const voteConfirm = ref(null)

onMounted(
  () => {
    axios.get('/vote/rest/ballotbox?electionId=' + route.query.electionId)
      .then(response => {
        candidates.value = {}
        election.value = {}
        token.value = {}
        election.value = response.data['election']
        candidates.value = response.data['candidates']
        token.value = response.data['token']
      })
  }
)

function createData () {
  let candidateInfo = {}

  for (var i = 0; i < candidates.value.length; i++) {
    candidateInfo['candidate' + i] = document.getElementsByName('candidate' + i)[0].value
    candidateInfo['candidateBox' + i] = document.getElementsByName('candidateBox' + i)[0].value
  }

  submitData.value['submitButton'] = document.getElementsByName('submitButton')[0].value
  submitData.value['clientToken'] = document.getElementsByName('clientToken')[0].value
  submitData.value['candidateInfo'] = candidateInfo
}

function submitForm () {
  axios.post('/vote/rest/ballotbox', submitData.value)
    .then(response => {
      if (response.data == 'OK') {
        router.push('/voting/confirmation')
      } else {
        invalidFlag.value = true
      }
    })
    .catch(() => {
      alert('You have timed out.', router.push('/voting/login'))
    })
}

function closeModal() {
  var modal = document.getElementById('voteConfirmModal')
  const greybg = document.querySelector(".modal-backdrop.fade.show")
  greybg.classList.remove("show");
  document.body.classList.remove("modal-open");
  modal.setAttribute("aria-hidden", "true");
  modal.classList.remove("show");
  modal.style.display = "none";
  greybg.remove();
}

function vote () {
  document.getElementById('submitVote').disabled = true
  document.getElementById('spoilVote').disabled = true
  voteConfirm.value.show('Are you sure you want to submit your vote?',
    () => {
      document.getElementById('submitButton').value = 'Submit Vote'
      createData()
      closeModal()
      submitForm()
      document.getElementById('submitVote').removeAttribute('disabled')
      document.getElementById('spoilVote').removeAttribute('disabled')
    },
    () => {
      closeModal()
      document.getElementById('submitVote').removeAttribute('disabled')
      document.getElementById('spoilVote').removeAttribute('disabled')
    }
  )
}

function spoil () {
  document.getElementById('submitVote').disabled = true
  document.getElementById('spoilVote').disabled = true
  voteConfirm.value.show('Are you sure you want to spoil your vote?',
    () => {
      document.getElementById('submitButton').value = 'Spoil Vote'
      createData()
      closeModal()
      submitForm()
    },
    () => {
      closeModal()
      document.getElementById('submitVote').removeAttribute('disabled')
      document.getElementById('spoilVote').removeAttribute('disabled')
    }
  )
}

</script>

<style>
.votingInputBox {
  float:right;
  width:48px;
  height:48px;
  background: rgba(118, 118, 128, 0.12);
  border-radius: 10px;
  border: 1px solid rgba(118, 118, 128, 0.12);
  text-align:center;
}
.votingInstructions {
  text-align:left;
  padding:auto;
  color: #4F5961;
}

.votingContainer {
  padding-left:5%;
  padding-right:5%;
  text-align:center;
}

.votingHdr {
  margin-top:10px;
  margin-bottom:10px;
  font-weight:bold;
  color: var(--uog-dark-blue); /* #686868 */
}

.votingSeatHdr {
  font-weight:bold;
  color:  var(--uog-dark-blue);
  margin-bottom:8px;
  margin-top:8px;
  margin-left:24px;
}

.voteButton {
  width:100%;
}

.voteButton:focus {

  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

#submitVote {
  border: 1px solid var(--uog-dark-blue);
  background-color: var(--uog-dark-blue);
  color:#ffffff;
  font-weight:700;
  border-radius:12px;
  margin-bottom:12px;
  margin-top:14px; /* 10 + 14 = 24 , TODO should write first/last child css methods */
}

#spoilVote {
  border: 1px solid var(--uog-dark-blue);
  background-color:#ffffff;
  color: var(--uog-dark-blue);
  font-weight:700;
  border-radius:12px;

}

.votingCandidate {
  height:72px;
  text-align:left;
  margin-bottom:10px;
  border: 1px solid #e4e4e4 !important;
  border-radius:24px !important;
  font-size:16px;
  font-weight:700;
}

#prefError {
  background-color: #FE416D;
  border: 1px solid #DE0663 !important;
  color:#ffffff;
  border-radius:6px !important;
}
</style>
